//= back-end-v2/src/domains/payments/api-schema-dtos/DisbursementInstructionDomainDtos.ts

 
import { type DisbursementSchedule } from './DisbursementSchedule'
import { type DisbursementInstructionState } from './DisbursementInstructionState'

export enum DisbursementAccountType {
   
  BITCOIN_ADDRESS = 'BitcoinAddress',
   
  BANK_ACCOUNT = 'BankAccount'
}

export class DisbursementBitcoinAddress {
  accountType: string = DisbursementAccountType.BITCOIN_ADDRESS
  bitcoinAddress!: string
}

export class DisbursementBankAccount {
  accountType: string = DisbursementAccountType.BANK_ACCOUNT
  accountHolderName!: string
  bankName!: string
  bankAccountNumber!: string
  branchCode!: string
}

export interface DisbursementAccountDetails {
  assetHolderId: number
  disbursementAccountId: number
  active: boolean
  currencyCode: string
  accountInfo: string
  accountDetails: DisbursementBitcoinAddress | DisbursementBankAccount
  lastPaidAtFormatted: string | null
  createdAtFormatted: string
  createdById: number
  createdByEmailAddress: string
  verifiedAndActive: boolean
  accountStatus: string
  accountStatusDescription: string
  verifiedAtFormatted: string | null
  verifiedByEmailAddress: string | null
  verifiedById: number | null
}

export interface DisbursementInstructionIdentifier {
  paymentInstructionId: number
  assetHolderId: number
  state: string
}

export interface DisbursementInstructionDetails {
  paymentInstructionId: number

  assetHolderId: number
  assetHolderName: string
  assetHolderEmailAddress: string

  schedule: string
  currencyCode: string
  isCancellable: boolean

  requestedAmount: number
  feeAmount: number
  payoutAmount: number
  requestAmountFormatted: string
  feeAmountFormatted: string
  payoutAmountFormatted: string
  state: string
  disbursementAccountId: number | null
  accountDetails: DisbursementBitcoinAddress | DisbursementBankAccount
  accountAddressInfo: string

  disbursementBatchId: number | null

  createdAt: Date
  createdAtFormatted: string
  confirmedAt: Date | null
  confirmedAtFormatted: string | null
  processedAt: Date | null
  processedAtFormatted: string | null
  processedByEmailAddress: string | null

  cancelledAtFormatted: string | null
  cancelledById: number | null
  cancelledByName: string | null
  cancelledByEmailAddress: string | null

  actionUnlink: boolean
}

export interface DisbursementInstructionSummary {
  id: number
  payoutSchedule: DisbursementSchedule
  currencyCode: string
  state: DisbursementInstructionState
  createdAtFormatted: string
  createdByEmail: string
  processedByEmail: string
  processedAtFormatted: string
  feeAmount: string
  payoutAmount: string
  requestedAmount: string
  isCancellable: boolean
}
